import React, { useEffect, useState, useCallback } from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { UpdatePollMessage } from '../../services/chat';
import { useChatMessages } from '../../hooks/chat';
import { getE2EEncryptionEnabledFlag } from '../../storage/index';

import {
  PollTitleStyle,
  PollSubtitle,
  PollOptionStyle,
  CustomCheckbox,
  StyledLinearProgress,
} from './styles';

const ViewPoll = ({ message, userGuid }) => {
  const { encryptChatMessage, decryptPollMessage } = useChatMessages();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pollData, setPollData] = useState(null);
  const isE2EEnabled = getE2EEncryptionEnabledFlag();

  const handleCheckboxChange = (event, selection) => {
    if (event.target.checked) {
      let removeUserInPollOption = null;

      // Handle Multiselect
      if (!pollData.multiSelect) {
        removeUserInPollOption = pollData.PollOptions.map((option) => ({
          ...option,
          isSelectedBy: option.isSelectedBy.filter((id) => id !== userGuid),
        }));
      }

      // add userId
      if (!selection.isSelectedBy.includes(userGuid)) {
        const option = {
          ...selection,
          isSelectedBy: [...selection.isSelectedBy, userGuid],
        };

        const updatePollOption = {
          ...pollData,
          PollOptions: pollData.multiSelect
            ? pollData.PollOptions.map((op) =>
                op.id === selection.id ? option : op
              )
            : removeUserInPollOption.map((op) =>
                op.id === selection.id ? option : op
              ),
        };

        setPollData(updatePollOption);
        updatePollMessage(updatePollOption);
      }
    } else {
      // remove userId
      const optionToUpdate = pollData.PollOptions.find(
        (option) => option.id === selection.id
      );

      if (optionToUpdate) {
        const updatedOptions = pollData.PollOptions.map((option) => {
          if (option.id === selection.id) {
            return {
              ...option,
              isSelectedBy: option.isSelectedBy.filter((id) => id !== userGuid),
            };
          }
          return option;
        });

        const updatePollOption = {
          ...pollData,
          PollOptions: updatedOptions,
        };
        setPollData(updatePollOption);
        updatePollMessage(updatePollOption);
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const updatePollMessage = useCallback(
    async (data) => {
      try {
        const updatedMessage = { ...message, Message: JSON.stringify(data) };

        if (isE2EEnabled === 'true') {
          const encryptedPollMessage = await encryptChatMessage(
            updatedMessage.Message,
            updatedMessage.ConversationGuid
          );
          updatedMessage.Message = encryptedPollMessage;
        }

        const result = await UpdatePollMessage({
          staffMessage: updatedMessage,
        });
        handleClose();
      } catch (error) {
        console.error('Error updating poll message:', error);
      }
    },
    [message]
  );

  // const updatePollMessage = useCallback(
  //   async (data) => {
  //     try {
  //       const updatedMessage = { ...message, Message: JSON.stringify(data) };
  //       const result = await UpdatePollMessage({
  //         staffMessage: updatedMessage,
  //       });
  //       handleClose();
  //     } catch (error) {
  //       console.error('Error updating poll message:', error);
  //     }
  //   },
  //   [message]
  // );

  // useEffect(() => {
  //   let pollMessage = null;
  //   try {
  //     pollMessage = JSON.parse(message.Message);
  //     const updatedPollMessage = {
  //       ...pollMessage,
  //       PollOptions: pollMessage.PollOptions.map((option) => ({
  //         ...option,
  //         isSelectedBy: option.isSelectedBy || [],
  //       })),
  //     };

  //     setPollData(updatedPollMessage);
  //   } catch (error) {
  //     console.error('Invalid JSON:', error);
  //     setPollData(null);
  //   }
  // }, [message]);

  // useEffect(() => {
  //   const decryptAndSetPollData = async () => {
  //     try {
  //       let rawMessage = message.Message;

  //       if (rawMessage.startsWith('ENC:')) {
  //         rawMessage = await decryptPollMessage(
  //           message.Message,
  //           message.ConversationGuid
  //         );
  //       }
  //       // 2. Parse the decrypted JSON
  //       const pollMessage = JSON.parse(rawMessage);

  //       // 3. Ensure poll options are initialized correctly
  //       const updatedPollMessage = {
  //         ...pollMessage,
  //         PollOptions: pollMessage.PollOptions.map((option) => ({
  //           ...option,
  //           isSelectedBy: option.isSelectedBy || [],
  //         })),
  //       };

  //       // 4. Set poll data to state
  //       setPollData(updatedPollMessage);
  //     } catch (error) {
  //       console.error('Error decrypting or parsing poll message:', error);
  //       setPollData(null);
  //     }
  //   };

  //   decryptAndSetPollData();
  // }, [message]);

  useEffect(() => {
    const parseMessage = async () => {
      try {
        let rawMessage = message.Message;

        if (isE2EEnabled === 'true') {
          if (rawMessage.startsWith('ENC:')) {
            rawMessage = await decryptPollMessage(
              message.Message,
              message.ConversationGuid
            );
          }
        }

        const pollMessage = JSON.parse(rawMessage);

        const updatedPollMessage = {
          ...pollMessage,
          PollOptions: pollMessage.PollOptions.map((option) => ({
            ...option,
            isSelectedBy: option.isSelectedBy || [],
          })),
        };

        setPollData(updatedPollMessage);
      } catch (error) {
        console.error(
          isE2EEnabled === 'true'
            ? 'Error decrypting or parsing poll message:'
            : 'Invalid JSON:',
          error
        );
        setPollData(null);
      }
    };

    parseMessage();
  }, [message]);

  if (!pollData) {
    return null;
  }

  return (
    <div>
      <PollTitleStyle>{pollData.PollTitle}</PollTitleStyle>
      <PollSubtitle>
        <p> {pollData.multiSelect ? 'select one or more' : 'select one'} </p>
      </PollSubtitle>
      <PollOptionStyle>
        {pollData.PollOptions.map((option) => (
          <div className="pollOptionContainer" key={option.id}>
            <div className="text">
              {
                <CustomCheckbox
                  id={`option${option.id}`}
                  name="pollOption"
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={
                    <CheckCircleOutlineIcon className="accent-icon" />
                  }
                  checked={option.isSelectedBy.includes(userGuid)}
                  onChange={(event) => handleCheckboxChange(event, option)}
                />
              }
              <label htmlFor={`option${option.id}`}> {option.text}</label>
              <span> {option.isSelectedBy.length} </span>
            </div>
            <div className="progressbar">
              <StyledLinearProgress
                variant="determinate"
                value={option.isSelectedBy.length > 0 ? 100 : 0}
                color="secondary"
              />
            </div>
          </div>
        ))}
      </PollOptionStyle>
    </div>
  );
};

export default ViewPoll;
